import { DoctoralServicePath } from "utils/constants";
import permissions from "app/permissions";
import ShowDoctoralRankingResults from "./Show";

export const resources = {
  name: `${DoctoralServicePath}doctoral-campaign-rankings`,
  show: <ShowDoctoralRankingResults />,
  permission: permissions.canPreviewDoctoralCampaignRankings,
};
